import {AppConfig} from './app.config';

export class AppUtils {

	static async delay(ms: number) {
		return new Promise(resolve => setTimeout(resolve, ms));
	}

	static scrollIntoView(elementId, inline: any = 'center') {
		const elementSelect = document.getElementById(elementId);
		if (elementSelect) {
			elementSelect.scrollIntoView({behavior: 'smooth', block: 'center', inline: inline});
		}
	}

	static async scrollToElement(elementId, content) {
		await this.delay(10);
		const element = document.getElementById(elementId);
		if (element != null) {
			await content.scrollToPoint(0, element.offsetTop - 50, AppConfig.scrollDuration);
		}
	}

	static isNum(v) {
		return !isNaN(v);
	}
}
